import { render } from "./my-team-numeric-sort.vue?vue&type=template&id=03a73e4c&ts=true"
import script from "./my-team-numeric-sort.vue?vue&type=script&lang=ts"
export * from "./my-team-numeric-sort.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__